import { render, staticRenderFns } from "./CommentButton.vue?vue&type=template&id=7aba9d26&"
import script from "./CommentButton.vue?vue&type=script&lang=ts&"
export * from "./CommentButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports